import styled from '@emotion/styled';
import ChevronDown from '@mui/icons-material/KeyboardArrowDown';
import { useAuth } from 'src/hooks';
import { Box, SvgIcon, Typography, usePopover } from 'src/components/atoms';
import { UserPicture } from 'src/components/logic';
import { LayoutUserPopover } from './LayoutUserPopover';

const Container = styled.div(
  ({ theme }) => `
  position: absolute;
  z-index: 500;
  top: 0.75rem;
  right: 0.75rem;

  display: flex;
  align-items: center;
  min-width: 13rem;
  border-radius: 7px;
  background-color: #303A4B;
  padding: ${theme.spacing(1.5)};
  cursor: pointer;
  transition: all .4s;

  max-width: 26rem;

  &:hover {
    background-color: ${theme.palette.background.paper};
  }
`
);

const StyledUserName = styled(Typography)`
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
`;

export const LayoutUser = () => {
  const { anchorEl, openPopover, closePopover } = usePopover();
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <>
      <Container onClick={openPopover}>
        <StyledUserName>{user.fullName}</StyledUserName>
        <SvgIcon sx={{ ml: 0.5, mr: 'auto' }}>
          <ChevronDown />
        </SvgIcon>
        <Box ml={1}>
          <UserPicture />
        </Box>
      </Container>
      <LayoutUserPopover anchorEl={anchorEl} onClose={closePopover} />
    </>
  );
};
